import './style.css';

import 'ui.buttons';
import 'ui.hint';
import { Loc, Extension, Event } from 'main.core';
import { SidePanel } from 'sidepanel';

const DEFAULT_BUTTON_CLASS = 'ui-btn ui-btn-light-border ui-icon-set__scope --air ui-btn-no-caps --with-left-icon --style-outline ui-btn-sm ui-btn-collapsed mcart-puppet-btn-icon';

class Main {
    mainWrapper = null;
    canAdd = false;

    constructor() {
        const settings = Extension.getSettings('mcart.puppet.main');
        this.canAdd = settings.canAdd;

        this.init();
    }

    init() {
        this.initEvent();
        this.initMainWrapper();
        this.initTaskWrapper(null);
    }

    initMainWrapper() {
        const wrapper = this.getMainWrapper();
        if (!wrapper) {
            return;
        }

        if (wrapper.querySelector('.mcart-puppet-btn-icon-puppet')) {
            return;
        }

        this.createButton(wrapper, {
            CLASS_NAME: DEFAULT_BUTTON_CLASS + ' mcart-puppet-btn-icon-puppet',
            HINT: Loc.getMessage('MCART_PUPPET_JS_MAIN__MAIN_BUTTON_HINT')
        }, this.onMainButtonClick);

        BX.UI.Hint.init(wrapper);
    }

    initTaskWrapper(event) {
        const wrapper = this.getTaskWrapper(event);

        if (!wrapper || this.getTaskId() <= 0) {
            return;
        }

        if (event?.data?.task?.id > 0 && this.getTaskId() != event.data.task.id) {
            return;
        }

        if (wrapper.querySelector('.mcart-puppet-btn-icon-puppet')) {
            return;
        }

        this.createButton(wrapper, {
            CLASS_NAME: DEFAULT_BUTTON_CLASS + ' mcart-puppet-btn-icon-puppet',
            HINT: Loc.getMessage('MCART_PUPPET_JS_MAIN__TASK_BUTTON_HINT')
        }, this.onTaskButtonClick, null, !this.canAdd);

        BX.UI.Hint.init(wrapper);
    }

    initEvent() {
        Event.EventEmitter.subscribe('tasks:full-card:init', BX.proxy((event) => this.initTaskWrapper(event), this));
    }

    getMainWrapper() {
        if (this.mainWrapper === null) {
            this.mainWrapper = document.querySelector('#header > div.air-header__personal-info > div.air-header__buttons');
        }

        return this.mainWrapper;
    }

    getTaskWrapper(event) {
        let taskWrapper = null;
        taskWrapper = document.querySelector('.task-detail-page #uiToolbarContainer > .ui-toolbar-right-buttons');
        if (event?.data?.task?.id > 0 && taskWrapper === null) {
            taskWrapper = [...document.querySelectorAll('.tasks-full-card[data-task-id="' + event.data.task.id + '"] .tasks-full-card-header')].at(-1);
        }

        return taskWrapper;
    }

    createButton(wrapper, config, handler, counter = null, disabled = false) {
        const button = BX.create({
            tag: 'button',
            props: {
                className: config.CLASS_NAME,
                disabled: disabled
            },
            dataset: {
                hint: config.HINT,
                hintNoIcon: '',
            },
            events: {
                click: BX.proxy(handler, this)
            },
            children: [
                BX.create({
                    tag: 'span',
                    props: {
                        className: 'ui-btn-text'
                    },
                    children: [
                        counter !== null ? BX.create({
                            tag: 'i',
                            props: {
                                className: 'ui-btn-counter'
                            },
                            text: counter
                        }) : null,
                        BX.create({
                            tag: 'span',
                            props: {
                                className: 'ui-btn-text-inner'
                            }
                        })
                    ]
                })
            ]
        });

        BX.append(button, wrapper);
    }

    getTaskId() {
        try {
            return parseInt(/\/tasks\/task\/view\/(\d*)\//.exec(window.location.pathname)[1]);
        } catch ($e) {
            return 0;
        }
    }

    onMainButtonClick() {
        this.openSidePanel('/mcart_puppet/', Loc.getMessage('MCART_PUPPET_JS_MAIN__MAIN_TITLE'));
    }

    onTaskButtonClick() {
        if (this.getTaskId() <= 0) {
            return;
        }

        this.openSidePanel('/mcart_puppet/', Loc.getMessage('MCART_PUPPET_JS_MAIN__TASK_TITLE'), {
            action: 'create_by_task',
            taskId: this.getTaskId(),
        });
    }

    openSidePanel(url, title, params = {}) {
        SidePanel.Instance.open(url, {
            title: title,
            cacheable: false,
            width: window.outerWidth,
            customLeftBoundary: 0,
            requestMethod: 'post',
            requestParams: params,
            events: {
                onLoad: function (event) {
                    const slider = event.getSlider();
                    if (slider.iframe) {
                        const doc = slider.iframe.contentDocument || slider.iframe.contentWindow.document;
                        if (doc && doc.documentElement) {
                            doc.documentElement.style.overflow = 'auto';
                        }
                    }
                }
            }
        });
    }

    setWaitButton(button, isWait) {
        button.classList.toggle('ui-btn-wait', isWait);
    }

    updateButtonCounter(button, total) {
        let counter = button.querySelector('.ui-btn-counter');

        if (!counter) {
            const wrapper = button.querySelector('.ui-btn-text');
            if (!wrapper) {
                return;
            }

            counter = BX.create({
                tag: 'i',
                props: {
                    className: 'ui-btn-counter'
                },
                text: total
            });
            BX.append(counter, wrapper);
        }

        counter.textContent = total;
    }
}

export { Main };
